import { render } from "./AppLogo.vue?vue&type=template&id=ed6eb270&ts=true"
import script from "./AppLogo.vue?vue&type=script&lang=ts"
export * from "./AppLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__